import React from 'react';
import { Box, Button, useDisclosure } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import ChooseTemplateModal from './ChooseTemplateModal';
import { PageTemplateCard } from 'components/PageTemplateCard';
import { MeetingAgendaTemplate } from 'apps/TenantApp/screens/Event/components/AgendaPlaceholder/MeetingAgendaTemplate';
import { useCommands, useEditorView } from '@remirror/react';
import { isDocNodeEmpty } from 'remirror';
import { MemoIcon } from 'components/icons';
import { CouncilMeetingAgendaTemplate } from 'apps/TenantApp/screens/Event/components/AgendaPlaceholder/CouncilMeetingAgendaTemplate';

export default function TemplateExtension() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const commands = useCommands();
  const view = useEditorView();

  const onUseTemplate = (content: string) => {
    commands.setContent(JSON.parse(content));
    onClose();
  };

  if (!isDocNodeEmpty(view.state.doc)) {
    return null;
  }

  return (
    <Box position="absolute" top="60px" p="10px">
      <Button
        size="sm"
        bg="blue.500"
        w="100%"
        color="gray.50"
        display="inline-block"
        p={2}
        _focus={{ bg: 'blue.600' }}
        _hover={{ bg: 'blue.600' }}
        _dark={{ bg: 'blue.600' }}
        onClick={onOpen}
        leftIcon={<MemoIcon />}
      >
        {t`Templates`}
      </Button>
      <ChooseTemplateModal
        isOpen={isOpen}
        onClose={onClose}
        availableTemplates={[
          <PageTemplateCard
            key="1"
            templateName={t`Quarterly board meeting - Type 1`}
            templateContent={JSON.stringify(MeetingAgendaTemplate)}
            onUseTemplate={onUseTemplate}
          />,
          <PageTemplateCard
            key="2"
            templateName={t`Council Meeting Agenda TEMPLATE`}
            templateContent={JSON.stringify(CouncilMeetingAgendaTemplate)}
            onUseTemplate={onUseTemplate}
          />,
        ]}
      />
    </Box>
  );
}
